import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const MODULE_MANAGEMENT_SIDEBAR_DATA = [
  {
    header: 'MODULE MANAGEMENT',
    tabs: [
      {
        tabName: 'Learner Level',
        to: '/module-management/mentee',
        subject: PERMISSION_SUBJECTS.menteeModule,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
      {
        tabName: 'Batch Level',
        to: '/module-management/batch',
        subject: PERMISSION_SUBJECTS.menteeModule,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default MODULE_MANAGEMENT_SIDEBAR_DATA;
